import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, Button, Column, Popover, TextField } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { FilterChip } from '../FilterChip/FilterChip';
import { currentValue, isExcludeMode, valueLabelFor } from './ModifiedByChip.utils';
export const GetModifiedByChipTID = (parentTestId)=>getTestIds(parentTestId);
export const ModifiedByChip = (param)=>{
    let { testId, predicate, onChange } = param;
    var _predicate_nin, _predicate_in;
    const { ModifiedByChipTestIds } = useMemo(()=>GetModifiedByChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('pages.draftsDashboard.aiSearch');
    const isExclude = isExcludeMode(predicate);
    const isSingleValue = (isExclude ? (_predicate_nin = predicate.nin) !== null && _predicate_nin !== void 0 ? _predicate_nin : [] : (_predicate_in = predicate.in) !== null && _predicate_in !== void 0 ? _predicate_in : []).length <= 1;
    const [anchorEl, setAnchorEl] = useState(null);
    const [draftValue, setDraftValue] = useState(currentValue(predicate));
    const toggleOperator = ()=>{
        onChange(isExclude ? {
            in: predicate.nin
        } : {
            nin: predicate.in
        });
    };
    const openPopover = (event)=>{
        setDraftValue(currentValue(predicate));
        setAnchorEl(event.currentTarget);
    };
    const closePopover = ()=>setAnchorEl(null);
    const apply = ()=>{
        const trimmed = draftValue.trim();
        if (trimmed.length === 0) {
            onChange(undefined);
        } else {
            onChange(isExclude ? {
                nin: [
                    trimmed
                ]
            } : {
                in: [
                    trimmed
                ]
            });
        }
        closePopover();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: t.modifiedByFieldLabel(),
                operator: {
                    label: isExclude ? t.operatorIsNot() : t.operatorIs(),
                    onToggle: toggleOperator,
                    biName: 'drafts_ai_search_chip_toggle_modified_by_operator'
                },
                valueLabel: valueLabelFor(predicate, t),
                onValueClick: isSingleValue ? openPopover : undefined,
                onRemove: ()=>onChange(undefined),
                removeBiName: "drafts_ai_search_chip_remove_modified_by"
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: ModifiedByChipTestIds.EditPopover(),
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: closePopover,
                children: /*#__PURE__*/ _jsx(Box, {
                    padding: 12,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            /*#__PURE__*/ _jsx(TextField, {
                                testId: ModifiedByChipTestIds.EditTextField(),
                                bi: {
                                    name: 'drafts_ai_search_chip_edit_modified_by'
                                },
                                value: draftValue,
                                onChange: (event)=>setDraftValue(event.target.value),
                                inputProps: {
                                    onKeyDown: (event)=>{
                                        if (event.key === 'Enter') {
                                            event.preventDefault();
                                            apply();
                                        }
                                    }
                                },
                                autoFocus: true
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                testId: ModifiedByChipTestIds.ApplyButton(),
                                bi: {
                                    name: 'drafts_ai_search_chip_apply_modified_by'
                                },
                                onClick: apply,
                                children: t.applyButton()
                            })
                        ]
                    })
                })
            })
        ]
    });
};
